import axios from 'axios';

axios.defaults.withCredentials = true;
export const api = axios.create({
  baseURL: '/api',
});

// WebSocket configuration
export const wsUrl = 'wss://78.28.152.228/ws';